export default (client) => {
  return {
    fetchAll() {
      return client.get(`/saas/faq/`)
    },
  }
}
